import React from 'react';
import {Modal,Box} from "@mui/material";

const modalStyle = {
      position: "absolute",
      top: "50%",
      left: "46%",
      transform: "translate(-50%, -50%)",
      width: "77%",
      height: "100%",
      bgcolor: "background.paper",
      overflowY: "scroll",
};

export const CommonModal = ({togal,toggleHandler,children}) => {

      return <Modal
            open={togal}
            onClose={toggleHandler}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
      >
            <Box sx={modalStyle}>
                  {children}
            </Box>
      </Modal>;

};